import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
// ngrx store
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';


// models
import { AppState } from '../../../booking/models/app-state.interface';
import { ProductData } from '../../models/product-data.interface';
import { BookingListstatus } from '../../globals';

@Component({
  selector: 'app-product-info',
  templateUrl: './product-info.component.html',
  styleUrls: ['./product-info.component.scss']
})
export class ProductInfoComponent implements OnInit, OnDestroy {

  @Input()
  parentProductData;

  @Input()
  bookingDetails;

  @Input()
  appCopy;

  @Input()
  selectedLanguage;

  private _flightSubscription: Subscription;
  private _bookingSubscription: Subscription;
  private _currentBookingSubscription: Subscription;
  private _bookingInitSubscription: Subscription;
  private _flightData;
  private _booking;
  private _currentBooking;
  private _bookingDetails;
  private _pathHasMyAccount = false;
  private _pathHasFlightDetails = false;
  private _firstLoad = true;

  public productData: ProductData = {
    airlineName: '',
    deliveryLocation: '',
    bookingABC: false,
    flightDirection: null,
    upgradeABC: false,
    isAirportToAirport: false
  };
  public productTitle = '';
  public productIcon = '';
  public productAction1 = '';
  public productAction2 = '';
  public productAction2_2 = '';
  public currentPartner = null;
  public airlinePartnerLogoName = '';

  public bookingListstatus = BookingListstatus;

  constructor(
    private _appStore: Store<AppState>,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  ngOnInit() {


    if (isPlatformBrowser(this.platformId)) {
      const path = window.location.pathname;
      const splitPath = path.split('/');

      if (splitPath.indexOf('my-account') > -1) {
        this._pathHasMyAccount = true;
        this.setDataSubscriptions();
      } else {

        this._bookingInitSubscription = this._appStore.select('loadedStatusReducer')
          .subscribe((res: any) => {
            // if booking data has bookingLoaded
            // show template and subscribe to data

            if (res.currentBookingLoaded && this._firstLoad) {
              this.setDataSubscriptions();
              this._firstLoad = false;
            } else if (!res.currentBookingLoaded) {

              if (this._bookingSubscription) { this._bookingSubscription.unsubscribe(); }
              if (this._flightSubscription) { this._flightSubscription.unsubscribe(); }
              if (this._currentBookingSubscription) { this._currentBookingSubscription.unsubscribe(); }
              this._flightData = false;
              this._currentBooking = false;
              this._booking = false;

            }
          });

        }

    }
console.log(this.bookingDetails)
  }

  setDataSubscriptions() {
    this.currentPartner = this.getState(this._appStore).partnerReducer.partnerName;

    if (!this._pathHasMyAccount) {
      this._currentBookingSubscription = this._appStore.select('currentBookingReducer')
        .subscribe((currentBooking: any) => {
          this._currentBooking = currentBooking.currentBooking;
          this.setProductData();
        });

      this._flightSubscription = this._appStore.select('flightReducer')
        .subscribe((flightData: any) => {
          this._flightData = flightData.flightDetails;
          this.setProductData();
        });

      this._bookingSubscription = this._appStore.select('bookingReducer')
        .subscribe((booking: any) => {
          this._booking = <AppState>booking;
          this.setProductData();
        });

    } else {
      this.productData = this.parentProductData;
      this.setViewData();
    }

console.log(this._booking, this._currentBooking, 'setDataSubscriptions')

  }

  setProductData() {

    if (this._flightData && this._currentBooking && this._booking) {

      if (Object.keys(this._currentBooking).length === 0) { return; }

      this.productData.airlineName = this._booking.bookingDetails.carrier.airlineName.replace(/\s/g, '').toLocaleUpperCase();
      this.productData.flightDirection = this._booking.bookingDetails.journeyLegDetails.length > 0 ? this._booking.bookingDetails.journeyLegDetails[0].journeyDirection : null;
      this.productData.bookingABC = this._booking.bookingDetails.bookingProduct === 'abc' ? true : false;
      this.productData.isAirportToAirport = this._booking.bookingDetails.isAirportToAirport;

      if (Object.keys(this._flightData.flightManualDestination).length === 0) {
        if (this.productData.bookingABC) {
          console.log('abc........')
          this.productData.deliveryLocation = this._flightData.flightFinalDestination.airportCityName;
        } else if (this.productData.flightDirection === 1 &&
            Object.keys(this._flightData.flightResponse).length !== 0) {
          this.productData.deliveryLocation = this._flightData.flightResponse.flightStatusDetails[0].departureAirport.airportName;
        } else if (this.productData.flightDirection === 2) {
          this.productData.deliveryLocation = !this.productData.isAirportToAirport ?
            this._currentBooking.bookingJourney[0].deliveryLocation.addressPostCode :
            this._currentBooking.bookingJourney[0].deliveryLocation.name;
        }
      } else {
        if (this.productData.flightDirection === 1) {
          this.productData.deliveryLocation = this._flightData.flightManualDestination.airportName;
        } else if (this.productData.flightDirection === 2) {
          if (!this.productData.isAirportToAirport) {
            this.productData.deliveryLocation = this._currentBooking.bookingJourney[0].deliveryLocation.addressPostCode ?
            this._currentBooking.bookingJourney[0].deliveryLocation.addressPostCode : '';
          } else {
            this.productData.deliveryLocation = this._currentBooking.bookingJourney[0].deliveryLocation.name;
          }
        }
      }
    }

    this.setViewData();
  }

  setViewData() {
    if (this.productData.bookingABC) {
      this.productTitle = 'Bag Check-In';
      this.productAction1 = 'We check in your bags, you collect them at';
      // this.productAction2 = 'You collect them in ';
      this.productAction2_2 = this.productData.deliveryLocation;

      this.productIcon = 'sprite--product-plane';
      this.airlinePartnerLogoName = this.productData.airlineName + '-partner-logo';
    } else {
      this.productTitle = 'Bag delivery';
      this.productAction1 = 'We collect your bags from the carousel and deliver them to you';
      // this.productAction2 = 'And deliver them to you ' + this.productData.deliveryLocation;
      // this.productAction2 = 'And deliver them to you ';
      this.productAction2_2 = '';
      this.productIcon = 'sprite--product-plane';
      this.airlinePartnerLogoName = this.productData.airlineName + '-partner-logo';
    }
    // if (this.productData.flightDirection === 1 || this.productData.flightDirection === 2 && this.productData.isAirportToAirport) {
    //   this.productTitle = 'Airport Delivery';
    //   this.productAction1 = 'We deliver your bags to ' + this.productData.deliveryLocation;
    //   this.productAction2 = 'You collect them from us before checking in';
    //   this.productIcon = 'sprite--product-airport';
    // } else if (this.productData.flightDirection === 2 && !this.productData.isAirportToAirport) {
    //   this.productTitle = 'City Delivery';
    //   this.productAction1 = 'You drop off your bags in the airport';
    //   this.productAction2 = 'We deliver them to ';
    //   this.productAction2 += this.productData.deliveryLocation ?
    //                           this.productData.deliveryLocation :
    //                           'your address';
    //   this.productIcon = 'sprite--product-city';
    // }


    // console.log(this._booking, this._currentBooking, this.getState(this._appStore))
    // if (!this.productData.bookingABC) {
    //   this.productTitle = 'Carosuel collection';
    //   this.productAction1 = 'We collect your bags';
    //   // this.productAction2 = 'And deliver them to you ' + this.productData.deliveryLocation;
    //   this.productAction2 = 'And deliver them to you ';
    //   this.productIcon = 'sprite--product-plane';
    //   this.airlinePartnerLogoName = this.productData.airlineName + '-partner-logo';
    // }
  }

  getAirlineLogoUrl(name) {
    let url = './images/airline-logo-full/' + name;
    url += name === 'THOMASCOOKAIRLINES' ? '.png' : '.svg';
    return url;
  }

  // get store state
  getState(store: Store<AppState>): AppState {
    let state: AppState;
    store.pipe(take(1))
    .subscribe(s => state = s);
    return state;
  }

  ngOnDestroy() {
    if (!this._pathHasMyAccount) {
      if (this._bookingSubscription) { this._bookingSubscription.unsubscribe(); }
      if (this._flightSubscription) { this._flightSubscription.unsubscribe(); }
      if (this._currentBookingSubscription) { this._currentBookingSubscription.unsubscribe(); }
      if (this._bookingInitSubscription) { this._bookingInitSubscription.unsubscribe(); }
    }
  }

}
